import { Link } from 'react-router-dom';

const RegionList = () => {
  const regions = ['North America', 'Latin America', 'Western Europe', 'Eastern Europe', 'Middle East','Asia', 'Africa', 'Oceania'];

  return (
    <div>
      <h1>Regions</h1>
      <ul>
        {regions.map((region) => (
          <li key={region}>
            <Link to={`/regions/${region}`}>{region}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RegionList;
